﻿import {translation} from "@2d-front-monorepo/core";
import {
	IMvvmContextState,
	MvvmTextInput,
	ValidationRequirementEntry,
	ValidationRequirements
} from "@2d-front-monorepo/design-library";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX, useCallback, useState} from "react";
import usePasswordRequiredPolicy from "../policies/passwordRequiredPolicy";

type Model = {
	password: string;
}

type UserPasswordProps = {
	context: IMvvmContextState<Model>
};

export default function UserPassword(props: UserPasswordProps): JSX.Element {
	const {context} = props;

	const [checkedItems, setCheckedItems] = useState<ValidationRequirementEntry[]>([
		{text: translation(PermitTranslations.validation__password_rules__01_text), checked: false},
		{text: translation(PermitTranslations.validation__password_rules__02_text), checked: false},
		{text: translation(PermitTranslations.validation__password_rules__03_text), checked: false},
		{text: translation(PermitTranslations.validation__password_rules__04_text), checked: false}
	]);

	const onPasswordChange = useCallback(function () {
		requestAnimationFrame(async () => {
			await context.validationEnds();
			const error = context.getError("password");
			const copy = structuredClone(checkedItems);
			if (error == null) {
				copy[0].checked = copy[1].checked = copy[2].checked = copy[3].checked = true;
			} else if (error.type == "password-02-requirement") {
				copy[0].checked = true;
				copy[1].checked = copy[2].checked = copy[3].checked = false;
			} else if (error.type == "password-03-requirement") {
				copy[0].checked = copy[1].checked = true;
				copy[2].checked = copy[3].checked = false;
			} else if (error.type == "password-04-requirement") {
				copy[0].checked = copy[1].checked = copy[2].checked = true;
				copy[3].checked = false;
			} else {
				copy[0].checked = copy[1].checked = copy[2].checked = copy[3].checked = false;
			}

			setCheckedItems(copy);
		});

	}, [context]);

	return <>
		<MvvmTextInput type="password"
		               context={context}
		               property="password"
		               autoComplete="new-password"
		               label={translation(PermitTranslations.sign_up_page__mandatory_password)}
		               validation={usePasswordRequiredPolicy(true)}
		               validateOnChange={true}
		               minLength={10}
		               onChange={onPasswordChange}/>

		<ValidationRequirements title={translation(PermitTranslations.validation__password_rules)}
		                        entries={checkedItems}/>
	</>;
};
